import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ProductdetailsComponent } from '../productdetails/productdetails.component';
import { ProductsearchComponent } from '../productsearch/productsearch.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  companyBO: any = {}
  groupColl: any = [];
  productColl: any = [];
  productgroupColl: any = [];

  productvariationColl: any = [];

  selectgroup: any = ""
  searchtxt: any = ""

  isshowcategory: boolean = false

  isvegonly: boolean = false

  isopensearch: boolean = false

  // _urlname: any = ""
  //productid: number = 0;

  @Input() urlname = ""
  @Input() tsname = null

  @Output() menuChanged = new EventEmitter<any>();

  routerEventSubscription = Subscription.EMPTY;




  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal,
    private toastr: ToastrService, private cuurenctRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.fngetProduct()
  }

  ngOnDestroy(): void {




  }


  fnGetUrlParameters() {



  }

  fngetProduct() {

    var data = {
      'urlname': this.urlname,
      'tsname': this.tsname,
    }

    console.log(data)
    this.appService.getProductDetailsByEmenu(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {
            var result = res.json().result;

            console.log(result)
            if (result.length > 0) {
              if (result[0].length > 0) {
                this.companyBO = result[0][0]
              }
              this.groupColl = result[1];
              this.productColl = result[2];
              this.productvariationColl = result[3];

              this.fnReloadProductList();

              if (this.companyBO.checkstatus !== "DONE") {
                this.menuChanged.emit(3)
              }
            }






            //console.log(this.productColl)
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }
        },
        (err) => {

          this.toastr.error('Error', err);
        })
  }

  fnReloadProductList() {


    this.productgroupColl = [];

    for (let gbo of this.groupColl) {
      let tempColl = []

      for (var pbo of this.productColl) {
        if (pbo.groupid === gbo.groupid) {
          if (this.isvegonly === true && pbo.foodsymbol === 'VEG') {
            tempColl.push(pbo);
          }
          else if (this.isvegonly === false) {
            tempColl.push(pbo);
          }
        }
      }

      var abo = {
        groupid: gbo.groupid,
        groupname: gbo.groupname,
        productColl: tempColl
      }
      if (tempColl.length > 0) {
        this.productgroupColl.push(abo)
      }
    }




    if (this.productgroupColl.length > 0) {
      this.selectgroup = this.productgroupColl[0].groupname
    }

  }



  fnGroupBtnClick(groupname) {
    this.selectgroup = groupname;

    let el = document.getElementById(groupname);
    el.scrollIntoView({ block: "start", inline: "nearest", behavior:"smooth"  });
  }

  fnGroupToggleBtnClick(groupname) {
    this.selectgroup = groupname;

    let el = document.getElementById(groupname);
    //  el.scrollIntoView({ block: "start", inline: "nearest" });



    var pos = el.style.position;
    var top = el.style.top;
    el.style.position = 'relative';
    el.style.top = '-50px';
    //el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    el.scrollIntoView({ block: "start", inline: "nearest" });
    el.style.top = top;
    el.style.position = pos;

    this.isshowcategory = false

  }



  fnProductClick(abo) {

    var deptid = abo.productid

    const modalRef = this.productFindService.open(ProductdetailsComponent, { size: <any>'m', backdrop: 'static' });
    modalRef.componentInstance.productid = deptid
    modalRef.componentInstance.productBO = abo
    modalRef.componentInstance.variationColl = this.fnGetProductVariration(deptid)
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });
  }


  fnSearchClick() {
    this.isopensearch=!this.isopensearch

    // const modalRef = this.productFindService.open(ProductsearchComponent, { size: <any>'m', backdrop: 'static' });
    // modalRef.componentInstance.productColl = this.productColl
    // modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    // });
  }


  fnGetProductVariration(productid) {

    var aColl = []

    for (let abo of this.productvariationColl) {
      if (abo.productid === productid) {
        aColl.push(abo)
      }
    }

    return aColl;

  }

}
